// reducers/door/index.js

import { combineReducers }  from 'redux';
import { doors }            from './doors';
import { doorsHasErrored }  from './doors';
import { doorsIsLoading }   from './doors';
import { search }           from './search';
import { searchHasErrored } from './search';
import { searchIsLoading }  from './search';
import { save }             from './save';
import { saveHasErrored }   from './save';
import { saveIsLoading }    from './save';

const doorsReducers = combineReducers({
  doors,
  doorsHasErrored,
  doorsIsLoading
});

const searchReducers = combineReducers({
  search,
  searchHasErrored,
  searchIsLoading
});

const saveReducers = combineReducers({
  save,
  saveHasErrored,
  saveIsLoading
});

export default combineReducers({
  doors: doorsReducers,
  search: searchReducers,
  save: saveReducers
});